export const ContactData = [
  {
    id: 1,
    text: "Please contact me for more information, I am ready to meet with you or have online meeting on business days! I am looking forward to hearing from you.",
    adress: "Gwangjin-gu, Seoul, South Korea",
    email: "bmuhibullaev@mail.ru",
    phone: "+8210 5705 1998",
    time: "Business days",
    facebook: "https://www.facebook.com/profile.php?id=100019405000330",

    instagram: "https://www.instagram.com/bobur_mv_/",
    linkedin: "https://kr.linkedin.com/in/boburmirzo-muhibullaev-32011a21a",
  },
];
